import React, { useState, useEffect } from 'react';
import './App.css';
import EntryForm from './components/EntryForm';
import EntriesList from './components/EntriesList';
import { fetchEntries, createEntry, updateEntry, deleteEntry } from './services/api';

function App() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [editingEntry, setEditingEntry] = useState(null);
  const [error, setError] = useState(null);

  // Fetch entries on component mount
  useEffect(() => {
    loadEntries();
  }, []);

  const loadEntries = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchEntries();
      setEntries(data);
    } catch (err) {
      setError('Failed to load entries. Please try again later.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = async (formData) => {
    try {
      setError(null);
      setSubmitting(true);
      if (editingEntry) {
        // Update existing entry
        await updateEntry(editingEntry.id, formData);
      } else {
        // Create new entry
        await createEntry(formData);
      }
      // Reload entries and clear form
      await loadEntries();
      setEditingEntry(null);
    } catch (err) {
      setError('Failed to save entry. Please try again.');
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleEdit = (entry) => {
    setEditingEntry(entry);
    // Scroll to form
    document.querySelector('.entry-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setEditingEntry(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this entry?')) {
      return;
    }

    try {
      setError(null);
      setDeletingId(id);
      await deleteEntry(id);
      await loadEntries();
      setEditingEntry(null);
    } catch (err) {
      setError('Failed to delete entry. Please try again.');
      console.error(err);
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Friendsgiving Organizer</h1>
        <p>Keep track of who's coming and what they're bringing</p>
      </header>

      <main className="app-main">
        <div className="container">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <EntryForm
            editingEntry={editingEntry}
            onFormSubmit={handleFormSubmit}
            onCancel={handleCancelEdit}
            submitting={submitting}
          />

          <EntriesList
            entries={entries}
            loading={loading}
            onEdit={handleEdit}
            onDelete={handleDelete}
            deletingId={deletingId}
          />
        </div>
      </main>

    </div>
  );
}

export default App;
